import { inject } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { CanActivateFn } from '@angular/router';
import { NavigationService } from '@services/nav/nav.service';
import { map, tap } from 'rxjs/operators';

export const AuthGuard: CanActivateFn = () => {
	const authFire = inject(AngularFireAuth);
	const navService = inject(NavigationService);
	return authFire.user.pipe(
		tap((user) => {
			if (user) {
				console.log('User is authenticated:', user);
			}
		}),
		// Observable of the currently signed-in user (or null).
		map(Boolean), // check if the user is authenticated
		tap((isAuth) => !isAuth && navService.goToLogin()), // redirect to the login page if the user is not authenticated
	);
};
